import { render } from "./CSectionText.vue?vue&type=template&id=94a64226&scoped=true"
const script = {}

import "./CSectionText.vue?vue&type=style&index=0&id=94a64226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94a64226"]])

export default __exports__